// URL is authoritative: Back/Forward and copied links restore the same cohort.
export function validWorkspaceDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
  const date = new Date(`${value}T00:00:00.000Z`)
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0,10) === value
}
export function workspaceFilters(params) {
  const owner=params.get('owner')||'', schoolTeamMemberId=params.get('schoolTeamMemberId')||'', invalid=[]
  const read=key=>{const raw=params.get(key)||'';if(!raw)return '';if(validWorkspaceDate(raw))return raw;invalid.push(key);return ''}
  const since=read('since'),until=read('until')
  return {owner,schoolTeamMemberId,since,until,invalid,query:{owner:owner||undefined,
    ...(schoolTeamMemberId?{schoolTeamMemberId}:{}),
    since:since?new Date(`${since}T00:00:00`).toISOString():undefined,
    until:until?new Date(`${until}T23:59:59.999`).toISOString():undefined}}
}
